/* hs-eslint ignored failing-rules */
/* eslint-disable no-prototype-builtins */

import { createSelector } from 'reselect';
import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Map as ImmutableMap, fromJS, List } from 'immutable';
import _ from 'underscore';
import { MODULE_TYPES, getModuleType, getModuleId } from 'EmailData/constants/DefaultModulesConstants';
import { FAKE_MODULES_NAMES } from 'ContentEditorUI/constants/FakeModulesConstants';
import { getSortedStaticModulesAndContainers, getHiddenModules } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { requestStarted } from 'redux-request-state/util/requestStateCheckers';
import { getBatchFetchModuleSchemasRequest } from 'ContentEditorUI/redux/selectors/requestStatesSelectors';
import { CLIENT_RENDERED_MODULES, determineMaxWidthOfElement, getAuthedDefaultModuleIds, getDefaultModuleIds, getDisplayOrderDefaultModuleIds, getInlineModuleIds, getIsBlogRssModule, getIsButtonModule, getIsEmailAbandonedCartModule, getIsEmailBodyModule, getIsEmailCartModule, getIsEmailProductModule, getIsEmailSurveyModule, getIsFooterModule, getIsImageModule, getIsModuleDefault, getIsWebVersionModule, getModuleIdsNotEnabledForSmartContent, getNonEditableModuleIds, getScopedModuleIds, getScopedModulesTypes, getWidgetIdsToAlwaysRenderWithV3, INLINE_TYPES, isButtonId, isDividerId, isFooterId, isGlobalModule, isWebversionId, MAX_EMAIL_WIDTH, MAX_SAFE_INTEGER, MODULES_WITH_MAX_WIDTH, getRecommendedModuleIDs, hasNoFieldsInContentTab
// @ts-expect-error Not typed yet
} from 'EmailEditorUI/utils/moduleUtils';
import { isEmptyObject, filterObjectValues } from 'ContentEditorUI/lib/collectionHelpers';
import { getRenderLanguage } from 'ContentEditorUI/redux/selectors/languageSelectors';
// @ts-expect-error Not typed yet
import { getIsBlogOrRssEmail } from 'EmailEditorUI/redux/selectors/EmailSelectors';
// @ts-expect-error Not typed yet
import { getContext } from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
import { getActiveBreakpointName, getIsInMobileBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';

// @ts-expect-error Not typed yet
import { getDefaultFromSpec } from 'EmailEditorUI/utils/fieldUtils';
import { getHubSetting } from 'EmailEditorUI/redux/selectors/hubSettingsSelectors';
// @ts-expect-error Not typed yet
import { convertCustomModuleSpec } from 'EmailEditorUI/data/transforms';
import { getWebfontsForTransform } from 'EmailEditorUI/redux/selectors/FontSelectors';
// @ts-expect-error Not typed yet
import { getSections, findContainingSection } from './sectionSelectors';
import { getHasCustomFooters, getHasEmailMultiSubscriptionsAccess, getHasEmailSmartContent, getIsUngatedForAssetLevelHublSupport, getCanUseCustomModules, getIsUngatedForSmartRulePreviewRefresh } from 'EmailEditorUI/redux/selectors/AuthSelectors';
import { getPortalHasMeetingsEmbed } from 'ContentEditorUI/redux/selectors/portalSelectors';
import { getHasLandingPagesAccess, getHasCtaAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
// @ts-expect-error Not typed yet
import { getIsTransactional } from 'EmailEditorUI/redux/selectors/subscriptionSelectors';
// @ts-expect-error Not typed yet
import { getModuleHasSmartContent } from 'ContentEditorUI/lib/smartContent/utils';
import { getContentWidgets, getUserModuleDefaults, hydrateWidgetFromSchemaAndContent } from 'ContentEditorUI/redux/selectors/moduleSelectorHelpers';
import { getIsSingleColumnFullWidth, getBodyBorderWidth, getContentFlexAreaStyleSettings
// @ts-expect-error Not typed yet
} from './styleSettingsSelectors';
import { getModules, getModuleById, getModulesWithSmartContent, getIsDefaultModule } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getSchemaForModule } from 'ContentEditorUI/redux/selectors/moduleSchemaSelectors';
import { getInpageNormalizedModules, getInpageModulesOutsideContainers } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { BUILTIN_FOOTER, BUILTIN_WEBVERSION, ELEMENT } from 'EmailEditorUI/constants/SidebarConstants';

// @ts-expect-error Not typed yet
import { isSmartEnabled } from 'ContentEditorUI/lib/smartContent/utils';
import { getIsCMv2Module, getAnyModuleById } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getIsABVariant } from 'ContentEditorUI/redux/selectors/abTestSelectors';
import { getMissingModuleIds, getContentSchemaWidgets
// @ts-expect-error Not typed yet
} from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
import { STYLE, CONTENT } from 'ContentUtils/constants/CustomWidgetFieldGroupTabTypes';
import { getIsDragDropEmail, getIsCustomEmail, getIsEmailTemplate } from 'EmailEditorUI/redux/selectors/emailCategoriesSelectors';
import { withModuleTabMigrationFilter, isDefaultModuleWithStyleField } from 'EmailEditorUI/constants/StyleFieldsMigration';
import { basicSelector, basicSelectorWithStats } from 'ContentEditorUI/redux/selectors/helpers';
import { HUB_SETTINGS } from 'EmailEditorUI/constants/HubSettingsForEditor';
import { STACK } from 'EmailEditorUI/constants/SectionLayoutConstants';
import { isHiddenForAllBreakpoints, isHiddenForBreakpoint, isHiddenForDefaultBreakpoint, isHiddenForMobileBreakpoint } from 'EmailEditorUI/utils/breakpointUtils';
import { getSelectedId, getModulesSearchTerm, getSelectedType } from 'EmailEditorUI/redux/selectors/selected';
import { getScopes } from 'EmailData/selectors/scopes';
import { doesTabHaveFields } from 'ContentComponents/components/cmv2/utils';
import sortBy from 'hs-lodash/sortBy';
import { getIsUpdatedTicketEmail } from 'EmailEditorUI/redux/selectors/ticketEmailSelectors';
const previewTextState = basicSelector(state => state.previewText);
export const getPreviewTextWidget = createSelector(previewTextState, previewText => {
  if (!(previewText.schemaWidgets && previewText.schemaWidgets['preview_text'])) {
    return null;
  }
  return hydrateWidgetFromSchemaAndContent(fromJS(previewText.schemaWidgets['preview_text']), fromJS(previewText.widgets['preview_text']), false);
});

// Note: The order of the selector dependencies matters. If we don't start with the selector that depends on
// PartialEmailModulesState, createSelector isn't able to tell that the email selector provides enough state
// for the CEUI selector
export const getEmailModules = createSelector([getPreviewTextWidget, getModules.gated], (previewText, modules) => previewText ? Object.assign({}, modules, {
  preview_text: previewText
}) : modules);
const getTranslationOptions = basicSelectorWithStats((state, yamlFriendlyName) => {
  if (yamlFriendlyName === 'blog_rss') {
    const isRss = state.contentModel && state.contentModel.emailType === 'RSS_EMAIL';
    return {
      // @ts-expect-error lookup doesn't exist on I18n type
      emailType: I18n.lookup(`CrossFrame.modules.label.${isRss ? 'rss' : 'blog'}_email_type`)
    };
  }
  return {};
});
export const getTranslatedModuleLabel = basicSelectorWithStats((state, moduleLabel, moduleId) => {
  const moduleType = getModuleType(moduleId);
  if (moduleType) {
    let yamlFriendlyName = moduleType.toLowerCase();
    if (yamlFriendlyName === 'button' && moduleLabel && moduleLabel.toLowerCase() === FAKE_MODULES_NAMES.PAYMENTS) {
      yamlFriendlyName = moduleLabel.toLowerCase();
    }
    if (isValidI18nKey(`CrossFrame.modules.label.${yamlFriendlyName}`)) {
      return I18n.text(`CrossFrame.modules.label.${yamlFriendlyName}`, getTranslationOptions(state, yamlFriendlyName));
    }
  }
  return moduleLabel;
});
const getElementByIdFunc = (elements, id) => {
  if (id) {
    return elements[id];
  }
  return null;
};
export const getRenderedModules = basicSelector(state => state.renderedModules);
export const getRenderedOutputById = basicSelectorWithStats((state, id, index = 0) => {
  const renderedModuleModel = getElementByIdFunc(getRenderedModules(state), id);
  if (index === 0) {
    return renderedModuleModel;
  }
  return renderedModuleModel === null || renderedModuleModel === void 0 ? void 0 : renderedModuleModel.forIndex(index);
});
export const getModuleLabelById = basicSelectorWithStats((state, id) => {
  const module = getModuleById(state, id);
  const schema = getSchemaForModule(state, module);
  const name = schema.name;
  const moduleId = schema.moduleId;
  return getTranslatedModuleLabel(state, name, moduleId);
});
export const getSectionWidgetsHelper = section => section.get('columns').flatMap(col => col.get('widgets')).toArray();
const getWidgetsOrderedByContent = createSelector(getSections, sections => {
  if (!sections) {
    return List();
  }
  return sections.flatMap(section => getSectionWidgetsHelper(section));
});
const _getTranslatedSmartModules = basicSelectorWithStats(state => {
  const modulesWithSmartContent = getModulesWithSmartContent.gated(state);
  return ImmutableMap(modulesWithSmartContent).map(m => {
    const moduleSchema = getSchemaForModule(state, m) || {};
    return m.set('label', moduleSchema.displayName || getTranslatedModuleLabel(state,
    // @ts-expect-error This could be undefined
    moduleSchema.name || m.get('label'), moduleSchema.moduleId || m.get('module_id')));
  });
});
export const getModulesWithSmartContentTranslated = createSelector([_getTranslatedSmartModules, getWidgetsOrderedByContent], (smartModules, orderedElementIds) => {
  // @ts-expect-error still finalizing central module type
  return smartModules.sortBy(m => orderedElementIds.indexOf(m.get('id')));
});
export const getNumberOfModulesWithSmartContent = createSelector([getModulesWithSmartContent], modulesWithSmartContent => Object.keys(modulesWithSmartContent).length);
export const getModulesEnabledForV3Translated = basicSelectorWithStats(state => {
  if (!getIsUngatedForAssetLevelHublSupport(state)) {
    return new Map();
  }
  const moduleEntries = Object.entries(getModules.gated(state)).filter(([, m]) => {
    const {
      isEnabledForEmailV3Rendering,
      moduleId
    } = getSchemaForModule(state, m) || {};
    return isEnabledForEmailV3Rendering || getWidgetIdsToAlwaysRenderWithV3().includes(moduleId);
  }).map(([name, m]) => {
    const moduleSchema = getSchemaForModule(state, m) || {};
    const updatedModule = m.set('label', moduleSchema.displayName || getTranslatedModuleLabel(state,
    // @ts-expect-error TODO: this could techincally be undefined
    moduleSchema.name || m.get('label'), moduleSchema.moduleId || m.get('module_id')));
    return [name, updatedModule];
  });
  if (moduleEntries.length > 1) {
    const orderedElementIds = getWidgetsOrderedByContent(state);
    return new Map(moduleEntries.sort(([, moduleA], [, moduleB]) => {
      // @ts-expect-error still finalizing central module type
      const moduleAId = moduleA.get('id');
      // @ts-expect-error still finalizing central module type
      const moduleBId = moduleB.get('id');
      return orderedElementIds.indexOf(moduleAId) - orderedElementIds.indexOf(moduleBId);
    }));
  }
  return new Map(moduleEntries);
});
export const getHasV3Modules = createSelector(getModulesEnabledForV3Translated, modulesEnabledForV3 => modulesEnabledForV3.size > 0);
export const getWidgetsFormattedForValidation = createSelector([getEmailModules], widgets => {
  const convertedWidgets = Object.fromEntries(Object.entries(widgets).map(([key, widget]) => [key, widget.toJS()]));
  return Object.entries(convertedWidgets).reduce((widgetMap, [key, widget]) => {
    widgetMap[key] = Object.assign({}, widget, {
      body: Object.assign({}, widget.body, {
        type: widget.type
      })
    });
    return widgetMap;
  }, {});
});
const getSyncedModuleSchemas = basicSelector(state => state.moduleSchemas);
export const getAllModuleSchemas = createSelector(getSyncedModuleSchemas, moduleSchemas => moduleSchemas.all);
export const getElements = basicSelector(state => getContentWidgets.gated(state));
export const getElementIdByModulePath = basicSelector((state, modulePath) => {
  var _elements$find;
  const elements = getElements(state);
  return (_elements$find = elements.find(el => el.get('body').get('path') === modulePath)) === null || _elements$find === void 0 ? void 0 : _elements$find.get('id');
});
export const getScopedModulesInUse = createSelector([getScopedModulesTypes, getElements], (scopedModules, elements) => {
  const mappedElements = elements.map(ele => getModuleType(ele.get('module_id')));
  return scopedModules.filter(locked => mappedElements.find(mappedEle => mappedEle === locked));
});
export const getLegacyBuiltinModules = createSelector([getRenderedModules, getModules.gated, getContext], (renderedModules, modules, context) => {
  let builtinWidgets = ImmutableMap();
  if (context.has_view_as_page_url && !Object.values(modules).find(module => isWebversionId(module.get('module_id')))) {
    builtinWidgets = builtinWidgets.set(BUILTIN_WEBVERSION, fromJS({
      id: BUILTIN_WEBVERSION,
      type: BUILTIN_WEBVERSION,
      label: I18n.text(`CrossFrame.modules.label.${BUILTIN_WEBVERSION}`),
      __hs_internal: true,
      name: BUILTIN_WEBVERSION,
      order: 0,
      _isBuiltIn: true,
      rendered: renderedModules[BUILTIN_WEBVERSION] && renderedModules[BUILTIN_WEBVERSION].isBuiltIn
    }));
  }
  if (!Object.values(modules).find(
  // @ts-expect-error TODO: Finalize central module type
  m => m.get('id') === 'email_footer' || isFooterId(m.get('module_id')))) {
    builtinWidgets = builtinWidgets.set(BUILTIN_FOOTER, fromJS({
      id: BUILTIN_FOOTER,
      type: BUILTIN_FOOTER,
      label: I18n.text(`CrossFrame.modules.label.${BUILTIN_FOOTER}`),
      __hs_internal: true,
      name: 'email_footer',
      order: 9999999,
      _isBuiltIn: true,
      rendered: renderedModules[BUILTIN_FOOTER] && renderedModules[BUILTIN_FOOTER].isBuiltIn
    }));
  }
  return builtinWidgets;
});
export const getElementById = basicSelectorWithStats((state, id) => {
  if (getIsCustomEmail(state) && (id === BUILTIN_FOOTER || id === BUILTIN_WEBVERSION)) {
    const builtinModule = getLegacyBuiltinModules(state).get(id);
    if (builtinModule) return builtinModule;
  }
  const modules = getInpageNormalizedModules(state);
  const module = modules.find(m => m.id === id || m.name === id);
  if (!module) {
    return fromJS(getAnyModuleById(state, id));
  }
  return fromJS(module);
});

// Custom selector over custom modules, not using reselect
// these schemas should not change from startup so its good to build them up
// as they are requested
const getModuleSpecSelector = (() => {
  const unconvertedSpecsMap = {};
  const convertedSpecsMap = {};
  const getCachedCustomModulesById = (customModuleSpecs, moduleId) => {
    if (unconvertedSpecsMap[moduleId]) {
      const module = unconvertedSpecsMap[moduleId];
      delete unconvertedSpecsMap[moduleId];
      return module;
    }
    let module = null;
    Object.values(customModuleSpecs).forEach(c => {
      if (c.moduleId === moduleId) {
        module = c;
      }
      unconvertedSpecsMap[c.moduleId] = c;
      return !module;
    });
    return module;
  };
  return moduleId => {
    if (convertedSpecsMap[moduleId]) return state => {
      let cached = convertedSpecsMap[moduleId];
      const currentRenderLanguage = getRenderLanguage(state);
      if (cached._renderLanguage !== currentRenderLanguage) {
        convertedSpecsMap[moduleId] = cached;
        const schema = getAllModuleSchemas(state)[`${cached.id}`];
        const messages = schema ? schema.messages : undefined;
        cached = Object.assign({}, cached, {
          _renderLanguage: currentRenderLanguage,
          // @ts-expect-error Messages should be defined
          messages
        });
      }
      return cached;
    };
    const isDefaultModuleId = getDefaultModuleIds().includes(moduleId);
    return state => {
      const allModuleSpecs = getAllModuleSchemas(state);
      const webfonts = getWebfontsForTransform(state);
      const moduleSpec = getCachedCustomModulesById(allModuleSpecs, moduleId);
      if (!moduleSpec) return {};
      const result = convertCustomModuleSpec(moduleSpec, webfonts, isDefaultModuleId, state);
      convertedSpecsMap[moduleId] = Object.assign({}, result, {
        _renderLanguage: getRenderLanguage(state)
      });
      return result;
    };
  };
})();
export const getModuleSpec = basicSelectorWithStats((state, moduleOrModuleId) => {
  let moduleId;
  if (typeof moduleOrModuleId === 'object' && moduleOrModuleId) {
    moduleId =
    // @ts-expect-error TS has a hard time resolving the keys for unions of TypedMaps
    moduleOrModuleId.get('module_id') || moduleOrModuleId.has('body') && moduleOrModuleId.getIn(['body', 'module_id']);
    if (!moduleId) {
      return getSchemaForModule(state, moduleOrModuleId.toJS());
    }
  } else {
    moduleId = moduleOrModuleId;
  }
  return getModuleSpecSelector(moduleId)(state);
});
const hasTokens = val => {
  if (typeof val === 'string' && /^{{\s*([a-zA-Z0-9_.]+)\s*}}$/.test(val) && !val.includes('contact.')) {
    return true;
  }
  if (typeof val === 'object' && val) {
    return Object.keys(val).some(k => hasTokens(val[k]));
  }
  return false;
};
export const getIsModuleUsingTokenValuesHelper = module => {
  return module.has('body') && hasTokens(module.get('body').toJS());
};
export const getModuleIsUsingTranslations = basicSelectorWithStats((state, module) => {
  const moduleSpec = getModuleSpec(state, module);
  if (moduleSpec.messages && moduleSpec.messages.hasOwnProperty('en')) {
    const defaults = Object.keys(moduleSpec.messages.en).filter(k => k.includes('default'));
    const propertyWithoutValueSetByUser = defaults.find(k => {
      return !module.hasIn(['body', ...k.replace('.default', '').split('.')]);
    });
    return !!propertyWithoutValueSetByUser;
  }
  return false;
});
export const getDoesTemplateUseModuleData = basicSelectorWithStats((state, module) => {
  if (getIsDragDropEmail(state) || !module) {
    // TODO: check this
    return false;
  }
  const moduleFromStore = getModuleById.gated(state, module.get('id'));
  if (moduleFromStore && moduleFromStore.get('export_to_template_context', false)) {
    return true;
  }
  return false;
});
export const getDoesModuleHasNoWrapper = basicSelectorWithStats((state, module) => {
  if (getIsDragDropEmail(state) || !module) {
    return false;
  }
  const moduleFromStore = getModuleById.gated(state, module.get('id'));
  // @ts-expect-error has no wrapper is not part of current module type
  return moduleFromStore && moduleFromStore.get('has_no_wrapper', false);
});
export const getIsSmartRulePreviewRefreshAvailable = basicSelectorWithStats((state, module) => {
  return getIsUngatedForSmartRulePreviewRefresh(state) && getDoesModuleHasNoWrapper(state, module);
});
const getSpecsForModuleIds = moduleIdsSelector => {
  return basicSelectorWithStats(state => {
    const ids = moduleIdsSelector(state).toArray();
    const result = ids.reduce((acc, id) => {
      const moduleSpec = getModuleSpec(state, id);
      if (isEmptyObject(moduleSpec)) return acc;
      acc[id] = moduleSpec;
      return acc;
    }, {});
    return result;
  });
};
export const getDefaultModuleSpecs = getSpecsForModuleIds(getAuthedDefaultModuleIds);
export const getDisplayOrderDefaultModuleSpecs = getSpecsForModuleIds(getDisplayOrderDefaultModuleIds);
export const getMarketplaceOrCreatedModuleSpecs = createSelector([getAllModuleSchemas, getCanUseCustomModules], (allModules, canUseCustomModules) => {
  if (!canUseCustomModules) {
    return {};
  }
  return filterObjectValues(allModules, spec => {
    const {
      contentTypes = []
    } = spec;
    return !getDefaultModuleIds().includes(spec.moduleId) && (contentTypes.includes('EMAIL') || contentTypes.includes('ANY'));
  });
});
export const getAllModuleIdsInSections = createSelector(getSections, sections => _.flatten(sections.map(s => s.get('columns').map(c => c.get('widgets'))).toJSON()));
export const getAllModuleIdsPerSection = createSelector(getSections, sections => sections.map(s => _.flatten(s.get('columns').map(c => c.get('widgets')).toJSON())));
export const getCanModuleBeMadeSmart = basicSelectorWithStats((state, element) => {
  if (getIsEmailTemplate(state)) return false;
  const moduleId = element.get('module_id');
  if (getIsEmailBodyModule(element)) return !getIsBlogOrRssEmail(state);
  if (getIsCMv2Module(state, element.get('name'))) {
    const moduleSpec = getModuleSpec(state, moduleId);
    return !getModuleIdsNotEnabledForSmartContent().includes(moduleId) && getHasEmailSmartContent(state) && !moduleSpec.global;
  } else {
    return isSmartEnabled(element.get('type'), element);
  }
});
export const getSmartCompatibleModules = basicSelectorWithStats(state => {
  const allModules = getModules.gated(state);
  return Object.fromEntries(Object.entries(allModules).filter(([, el]) => getCanModuleBeMadeSmart(state, el)).sort(([, moduleA], [, moduleB]) =>
  // @ts-expect-error Immutable with unions is a bit weird
  moduleA.get('order') - moduleB.get('order')));
});
export const getCanCreateSmartModules = basicSelectorWithStats(state => {
  return Object.keys(getSmartCompatibleModules(state)).length > 0;
});
export const getElementByElementId = (state, elementId) => {
  const elements = getElements(state);
  return elements.get(elementId);
};
export const getElementFromModuleId = basicSelectorWithStats((state, moduleId) => {
  const elements = getElements(state);
  return elements.find(element => element.get('module_id') === Number(moduleId));
});
export const getIsModuleEditable = basicSelectorWithStats((state, moduleId, elementId = null) => {
  if (elementId) {
    const element = getElementByElementId(state, elementId);
    const isCustomModule = !getIsModuleDefault(element);
    if (isCustomModule) {
      return getCanUseCustomModules(state);
    }
  }
  return !getNonEditableModuleIds(state).includes(moduleId) && !getScopedModuleIds(state).includes(moduleId);
});
export const getSelectedElement = basicSelectorWithStats(state => {
  const selectedId = getSelectedId(state);
  const selectedType = getSelectedType(state);
  if (selectedType !== ELEMENT && !selectedId) {
    return null;
  }

  // @ts-expect-error TODO, mixing string and number as ids
  return getElementById(state, selectedId);
});
export const getSelectedSchemaWidget = createSelector([getContentSchemaWidgets, getSelectedId, getSelectedType], (schemaWidgets, selectedId, selectedType) => {
  if (selectedType !== ELEMENT && !selectedId) {
    return null;
  }
  // @ts-expect-error TODO: selectedId could be undefined still
  return fromJS(schemaWidgets[selectedId]);
});
export const getModulesInsideFlexArea = createSelector([getInpageNormalizedModules, getAllModuleIdsInSections], (modules, modulesIdsInFlexArea) => {
  return modules.filter(module => !module.isInContainer && !module.layout_section_id && modulesIdsInFlexArea.includes(module.id));
});
export const getIsModuleInsideFlexArea = basicSelectorWithStats((state, moduleId) => !!getModulesInsideFlexArea(state).find(m => m.id === moduleId));
export const getIsModuleInlineEditable = basicSelectorWithStats((state, moduleId, element = null) => {
  if (element && getIsEmailBodyModule(element)) return !getIsBlogOrRssEmail(state);
  if (element && !getIsModuleInsideFlexArea(state, element.get('id')) && (getDoesModuleHasNoWrapper(state, element) || getDoesTemplateUseModuleData(state, element))) {
    return false;
  }
  return getInlineModuleIds(state).includes(moduleId) || element && INLINE_TYPES.includes(element.get('type'));
});
export const getIsClientRenderedModule = basicSelectorWithStats((element, state) => {
  return element && getIsModuleInsideFlexArea(state, element.get('id')) && CLIENT_RENDERED_MODULES.includes(getModuleType(element.get('module_id'))) || getIsModuleInlineEditable(state, element.get('module_id'), element);
});
export const getSelectedElementSpecIsMissing = createSelector([getMissingModuleIds, getSelectedSchemaWidget], (missingModuleIds, selectedSchemaWidget) => {
  const id = selectedSchemaWidget && (selectedSchemaWidget.get('module_id') || selectedSchemaWidget.getIn(['body', 'widget_name']) || selectedSchemaWidget.get('widget_name') || selectedSchemaWidget.get('label'));
  if (id) {
    return missingModuleIds.includes(id.toString());
  }
  return false;
});
export const getSchemaForSelectedModule = createSelector([getSelectedElement, state => state], (selectedElement, state) => selectedElement && getSchemaForModule(state, selectedElement));
export const getSelectedElementHasEditForm = basicSelectorWithStats(state => {
  const selectedElement = getSelectedElement(state);
  if (!selectedElement) {
    return false;
  }
  if (getIsBlogOrRssEmail(state) && getIsEmailBodyModule(selectedElement)) {
    return true;
  }
  let cmv2hasEditForm = true;
  const moduleId = selectedElement && selectedElement.get('module_id');
  if (getIsCMv2Module(state, selectedElement.get('name'))) {
    const inlineIds = getInlineModuleIds(state);
    const nonEditableIds = getNonEditableModuleIds(state);
    const isSmartRulePreviewRefreshAvailable = getIsSmartRulePreviewRefreshAvailable(state, selectedElement);
    cmv2hasEditForm = moduleId && (!inlineIds.includes(moduleId) || isSmartRulePreviewRefreshAvailable) && !nonEditableIds.includes(moduleId);
  }
  const moduleType = selectedElement && selectedElement.get('type');
  return cmv2hasEditForm && (!moduleType || !getIsModuleInlineEditable(state, moduleId, selectedElement)) && !getIsEmailSurveyModule(selectedElement);
});
export const getSelectedModuleSpec = state => {
  const selectedElement = getSelectedElement(state);
  if (selectedElement) {
    return getModuleSpec(state, selectedElement);
  }
  return {};
};
export const getSelectedElementIsEditable = basicSelectorWithStats(state => {
  const selectedElement = getSelectedElement(state);
  if (!selectedElement) {
    return false;
  }
  const moduleSpec = getSelectedModuleSpec(state);
  const isModuleInsideFlexArea = getIsModuleInsideFlexArea(state, selectedElement.get('id'));
  const isGlobal = isGlobalModule(selectedElement, moduleSpec);
  const isOverrideable = selectedElement.get('overrideable');
  const isGlobalModuleInsideFlexArea = isGlobal && isModuleInsideFlexArea;
  return !isGlobal && isOverrideable || isGlobalModuleInsideFlexArea;
});
export const checkModuleHasSmartRules = module => {
  return module && module.has('smart_objects') && !module.get('smart_objects').isEmpty() && !!module.get('definition_id');
};
export const getSelectedElementHasSmartRules = createSelector(getSelectedElement, element => checkModuleHasSmartRules(element));
export const getIsEditingSmartVariation = createSelector(getSelectedElement, element => Boolean(element === null || element === void 0 ? void 0 : element.get('selectedSmartRuleId')));
export const getSelectedElementIsPartiallyEditable = createSelector([getSelectedElement], selectedElement => {
  if (!selectedElement) {
    return false;
  }
  return !selectedElement.get('overrideable') && (getIsFooterModule(selectedElement) || getIsWebVersionModule(selectedElement));
});
export const getAuthedSelectedModuleSpec = createSelector([getSelectedModuleSpec, getHasLandingPagesAccess, getHasCtaAccess, getHasEmailMultiSubscriptionsAccess, getPortalHasMeetingsEmbed], (moduleSpec, hasLandingPagesAccess, hasCtaAccess, hasEmailMultiSubscriptionsAccess, hasMeetingsAccess) => {
  if (!isButtonId(moduleSpec.moduleId)) {
    return moduleSpec;
  }
  const linkToIndex = moduleSpec.fields.findIndex(field => field.name === 'link_to');
  const subscriptionTypeIndex = moduleSpec.fields.findIndex(field => field.name === 'subscription_type');
  let authedModuleSpec = moduleSpec;
  const newFields = Array.from(moduleSpec.fields);
  if (linkToIndex > -1) {
    newFields[linkToIndex] = Object.assign({}, newFields[linkToIndex], {
      choices: newFields[linkToIndex].choices.filter(choice => {
        const value = choice[0];
        if (value === 'meetings_link') {
          return hasMeetingsAccess;
        } else if (value === 'page') {
          return hasLandingPagesAccess;
        } else if (value === 'cta') {
          return hasCtaAccess;
        } else if (value === 'payments') {
          return false;
        }
        return true;
      })
    });
    authedModuleSpec = Object.assign({}, moduleSpec, {
      fields: newFields
    });
  }
  if (subscriptionTypeIndex > -1 && !hasEmailMultiSubscriptionsAccess) {
    newFields[subscriptionTypeIndex] = Object.assign({}, newFields[subscriptionTypeIndex], {
      choices: newFields[subscriptionTypeIndex].choices.filter(choice => {
        return choice[0] !== 'view_webpage';
      })
    });
    authedModuleSpec = Object.assign({}, moduleSpec, {
      fields: newFields
    });
  }
  return authedModuleSpec;
});
const createModuleSpecSelectorForModuleType = type => basicSelectorWithStats(getModuleSpecSelector(getModuleId(type)));
export const getImageModuleSpec = createModuleSpecSelectorForModuleType(MODULE_TYPES.IMAGE);
export const getVideoModuleSpec = createModuleSpecSelectorForModuleType(MODULE_TYPES.EMAIL_VIDEO);
export const getWebVersionLinkModuleSpec = createModuleSpecSelectorForModuleType(MODULE_TYPES.WEB_VERSION_LINK);
export const getFooterModuleSpec = createModuleSpecSelectorForModuleType(MODULE_TYPES.FOOTER);
export const getIsSelectedModuleImage = createSelector([getSelectedElement], element => {
  return !!element && getIsImageModule(element);
});
export const getIsSelectedModuleDefault = basicSelectorWithStats(state => {
  return getIsModuleDefault(getSelectedElement(state));
});
const returnFalse = () => false;
const makeHasModuleInDndByCondition = (condition = returnFalse) => createSelector([getElements, getAllModuleIdsInSections], (elements, widgets) => {
  const modulesMatched = elements.reduce((red, val, key) => {
    if (condition(val)) {
      red.push(key);
    }
    return red;
  }, []);
  return widgets.some(val => {
    return modulesMatched.indexOf(val) > -1;
  });
});
const makeSearchModulesInDndByCondition = (condition = returnFalse) => createSelector([getElements, getAllModuleIdsInSections], (elements, widgets) => {
  const modulesMatched = elements.reduce((red, val, key) => {
    if (condition(val) && widgets.indexOf(key) > -1) {
      red.push(val);
    }
    return red;
  }, []);
  return modulesMatched;
});
export const hasFooterModule = makeHasModuleInDndByCondition(val => getIsFooterModule(val));
export const getHasAbandonedCartModule = makeHasModuleInDndByCondition(getIsEmailAbandonedCartModule);
export const getHasCartModule = makeHasModuleInDndByCondition(getIsEmailCartModule);
export const getHasProductsModule = makeHasModuleInDndByCondition(getIsEmailProductModule);
export const hasEcommerceModules = makeHasModuleInDndByCondition(val => getIsEmailProductModule(val) || getIsEmailAbandonedCartModule(val) || getIsEmailCartModule(val));
export const getEcommModulesWithRecommendations = makeSearchModulesInDndByCondition(val => getIsEmailProductModule(val) && val.getIn(['body', 'product_module_type']) === 'recommended_products');
export const getCartModulesInUse = makeSearchModulesInDndByCondition(getIsEmailCartModule);
export const hasPaymentsLinkInCTA = createSelector([getModules.gated], modules => {
  const buttonModuleWithPayment = Object.values(modules).filter(module => isButtonId(module.get('module_id')) && module.get('body').get('link_to') === 'payments');
  return buttonModuleWithPayment.length > 0;
});
export const hasEcommRecommendations = createSelector([getEcommModulesWithRecommendations], ecommModulesWithRecommendations => {
  return ecommModulesWithRecommendations.length > 0;
});
export const getIsSelectedModuleUsingEcommRecommendations = createSelector([getSelectedElement, getEcommModulesWithRecommendations], (selectedSelement, ecommModulesWithRecommendations) => {
  if (!selectedSelement) return false;
  return !!ecommModulesWithRecommendations.find(m => m.get('id') === selectedSelement.get('id'));
});
export const getRecommendationsTypes = createSelector([getEcommModulesWithRecommendations], modulesWithRecommendations => modulesWithRecommendations ? modulesWithRecommendations.map(m => m.getIn(['body', 'recommendation_algorithm'])) : []);
const getElementsFilteredFunction = filterFunc => createSelector(getElements, elements => elements.reduce((filtered, element, key) => {
  if (filterFunc(element)) {
    filtered.push(key);
  }
  return filtered;
}, []));
export const getImageModules = getElementsFilteredFunction(getIsImageModule);
export const getButtonModules = getElementsFilteredFunction(getIsButtonModule);
export const getWebVersionElementIds = getElementsFilteredFunction(getIsWebVersionModule);
const getFooterElements = getElementsFilteredFunction(getIsFooterModule);
const getBlogRssElements = getElementsFilteredFunction(getIsBlogRssModule);
export const getEmailHasFooterModule = createSelector([getFooterElements, getAllModuleIdsInSections, getRenderedModules], (footerElements, widgets, renderedModules) => {
  return footerElements.length > 0 && widgets.some(val => {
    return footerElements.indexOf(val) > -1;
  }) || !!renderedModules[BUILTIN_FOOTER];
});
export const hasWebVersionLinkModule = createSelector([getWebVersionElementIds, getAllModuleIdsInSections], (webVersionElements, widgets) => widgets.some(val => {
  return webVersionElements.indexOf(val) > -1;
}));
export const sectionHasFooterModule = basicSelectorWithStats((state, section) => {
  const footerElements = getFooterElements(state);
  const widgets = getSectionWidgetsHelper(section);
  return widgets.some(val => {
    return footerElements.indexOf(val) > -1;
  });
});
export const sectionHasLastFooterModule = basicSelectorWithStats((state, section) => {
  const footerElements = getFooterElements(state);
  const widgets = getSectionWidgetsHelper(section);
  return footerElements.length > 0 && footerElements.every(footer => widgets.includes(footer));
});
export const getFooterSectionIndex = createSelector([getSections, getAllModuleIdsPerSection, getFooterElements], (sections, widgets, footerElements) => {
  for (let i = sections.size - 1; i >= 0; i--) {
    const hasFooter = widgets.get(i).some(val => {
      return footerElements.indexOf(val) > -1;
    });
    if (hasFooter) {
      return i;
    }
  }
  return null;
});
export const getFooterId = createSelector(getFooterElements, footerElements => {
  return footerElements.length ? footerElements[footerElements.length - 1] : null;
});
export const sectionHasBlogRssModule = basicSelectorWithStats((state, section) => {
  const blogRssElements = getBlogRssElements(state);
  const widgets = getSectionWidgetsHelper(section);
  return widgets.some(val => {
    return blogRssElements.indexOf(val) > -1;
  });
});
export const sectionHasWebversionLinkModule = basicSelectorWithStats((state, section) => {
  const webVersionElements = getWebVersionElementIds(state);
  const widgets = getSectionWidgetsHelper(section);
  return widgets.some(val => {
    return webVersionElements.indexOf(val) > -1;
  });
});
export const sectionHasWebversionAndIsVariant = basicSelectorWithStats((state, section) => {
  if (!getIsABVariant(state)) {
    return false;
  }
  return sectionHasWebversionLinkModule(state, section);
});
const elementIsWebversionAndIsVariant = basicSelectorWithStats((state, element) => {
  if (!getIsABVariant(state)) {
    return false;
  }
  return getIsWebVersionModule(element);
});
export const elementIsLastFooterModule = basicSelectorWithStats((state, id) => {
  const footerElements = getFooterElements(state);
  return footerElements.length === 1 && footerElements[0] === id;
});
export const getCanDeleteFooter = createSelector([getHasCustomFooters, getIsTransactional], (hasCustomFooters, isTransactional) => hasCustomFooters || isTransactional);
export const getCanHideElement = basicSelectorWithStats((state, element) => {
  return !elementIsLastFooterModule(state, element.get('id')) || getCanDeleteFooter(state);
});
export const getCanDeleteElement = basicSelectorWithStats((state, element) => {
  return getCanHideElement(state, element) && !getIsBlogRssModule(element) && !getIsEmailSurveyModule(element) && !elementIsWebversionAndIsVariant(state, element);
});
export const getCanCloneElement = basicSelectorWithStats((state, moduleId, elementId = null) => {
  if (elementId) {
    const element = getElementByElementId(state, elementId);
    const isCustomModule = !getIsModuleDefault(element);
    if (isCustomModule) {
      return getCanUseCustomModules(state);
    }
  }
  return !getScopedModuleIds(state, moduleId).includes(moduleId);
});
export const getCanHideSection = basicSelectorWithStats((state, section) => {
  return !sectionHasLastFooterModule(state, section) || getCanDeleteFooter(state);
});
export const getCanDeleteSection = basicSelectorWithStats((state, section) => {
  return getCanHideSection(state, section) && !sectionHasBlogRssModule(state, section) && !sectionHasWebversionAndIsVariant(state, section);
});
export const getElementsWithMaxWidth = createSelector([getSections, getElements, getIsSingleColumnFullWidth, getBodyBorderWidth, getIsDragDropEmail, getModulesInsideFlexArea], (sections, elements, isSingleColumnFullWidth, bodyBorderWidth, isDragDropEmail, modulesInsideFlexArea) => {
  return elements.map(element => {
    if (MODULES_WITH_MAX_WIDTH.includes(getModuleType(element.get('module_id')))) {
      const hasNoMaxWidth = isSingleColumnFullWidth || !isDragDropEmail && !modulesInsideFlexArea.find(m => m.id === element.get('id'));
      return element.set('maxWidth', determineMaxWidthOfElement(element, sections, hasNoMaxWidth, bodyBorderWidth));
    }
    return element;
  });
});
export const getBlogRssModuleContainerMaxWidth = createSelector([getElementsWithMaxWidth, getIsSingleColumnFullWidth], (elements, isSingleColumnFullWidth) => {
  if (isSingleColumnFullWidth) return null;
  const blogRssModule = elements.find(getIsBlogRssModule);
  if (blogRssModule) {
    return blogRssModule.get('maxWidth');
  }
  return null;
});
export const getMaxWidthOfSelectedElement = createSelector([getSelectedElement, getSections, getIsSingleColumnFullWidth, getBodyBorderWidth], determineMaxWidthOfElement);
const getIsModuleGlobal = basicSelectorWithStats((state, element) => {
  const moduleSpec = getModuleSpec(state, element);
  return moduleSpec.global;
});
export const getModulesThatAreNotInstantlyDeletable = basicSelectorWithStats((state, elementIds) => {
  return elementIds.reduce((els, id) => {
    const elements = getElements(state);
    const element = elements.get(id);
    if (getModuleHasSmartContent(element) && !getIsModuleGlobal(state, element)) {
      return [...els, {
        id,
        definitionId: element.get('definition_id'),
        criteriaIds: element.get('smart_objects').map(s => s.get('criterion_id')).toJS(),
        hasSmartContent: true
      }];
    } else if (elementIsLastFooterModule(state, id) && !getIsTransactional(state)) {
      return [...els, {
        id,
        isFooterModule: true
      }];
    }
    return els;
  }, []);
});
const getDefaultColorForDivider = basicSelectorWithStats((state, element) => {
  const designPanelColor = getUserModuleDefaults(state).getIn(['email_divider', 'color', 'color']);
  if (designPanelColor) {
    return designPanelColor;
  }
  const defaultModuleColor = getDefaultFromSpec(getModuleSpec(state, element), 'color');
  return defaultModuleColor === null || defaultModuleColor === void 0 ? void 0 : defaultModuleColor.color;
});
export const getStyleSettingsDefaultColorForField = basicSelectorWithStats((state, fieldName) => {
  const selectedElement = getSelectedElement(state);
  if (!selectedElement) {
    return null;
  }
  const selectedId = selectedElement.get('module_id');
  if (isButtonId(selectedId)) {
    switch (fieldName) {
      case 'background_color':
        return getUserModuleDefaults(state).getIn(['button_email', 'background_color']);
      case 'font_style':
        return getUserModuleDefaults(state).getIn(['button_email', 'font_style', 'color']);
      default:
        return null;
    }
  } else if (isDividerId(selectedId) && fieldName === 'color') {
    return getDefaultColorForDivider(state, selectedElement);
  } else if (isFooterId(selectedId)) {
    switch (fieldName) {
      case 'font':
        return getContentFlexAreaStyleSettings(state).get('primary_font_color');
      case 'link_font':
        return getContentFlexAreaStyleSettings(state).getIn(['links_font', 'color']);
      default:
        return null;
    }
  } else if (isWebversionId(selectedId) && fieldName === 'font') {
    return getContentFlexAreaStyleSettings(state).getIn(['links_font', 'color']);
  }
  return null;
});
export const getStyleSettingsDefaultForElement = basicSelectorWithStats((state, moduleId, ...fieldName) => {
  if (isButtonId(moduleId)) {
    return getUserModuleDefaults(state).getIn(['button_email', ...fieldName]);
  }
  if (isDividerId(moduleId)) {
    return getUserModuleDefaults(state).getIn(['email_divider', ...fieldName]);
  }
  return null;
});
export const MODULE_IDS_SEPARATOR = ',';
export const getRecentModuleSpecsAsArray = basicSelectorWithStats(state => {
  const canUseCustomModules = getCanUseCustomModules(state);
  const recentlyUsedModulesIdsString = getHubSetting(state, HUB_SETTINGS.RECENTLY_USED_MODULES);
  let recentlyUsedModulesIds;
  try {
    recentlyUsedModulesIds = recentlyUsedModulesIdsString.split(MODULE_IDS_SEPARATOR);
  } catch (ex) {
    recentlyUsedModulesIds = [];
  }
  const recentlyUsedModulesSpecs = [];
  recentlyUsedModulesIds.forEach(rm => {
    if (rm) {
      const defaultModulesAvailable = getDisplayOrderDefaultModuleIds(state);
      const moduleSpec = getModuleSpec(state, rm);
      const isCustomModule = !getIsModuleDefault(moduleSpec);
      const isUnavailableDefaultModule = !isCustomModule && !defaultModulesAvailable.includes(Number(rm));
      if (isCustomModule && !canUseCustomModules || isEmptyObject(moduleSpec) || isUnavailableDefaultModule) {
        return;
      }
      recentlyUsedModulesSpecs.push(moduleSpec);
    }
  });
  return recentlyUsedModulesSpecs;
});
export const getRecentlyUsedModulesIds = createSelector([getRecentModuleSpecsAsArray], recentModules => recentModules.map(recent => recent.moduleId));
export const getIsPaymentModuleVisible = createSelector([getModulesSearchTerm, getIsUpdatedTicketEmail], (searchTerm, isTicketEmail) => {
  if (isTicketEmail) {
    return false;
  }
  const label = I18n.text('CrossFrame.modules.label.payments');
  const searchTermMatchesPayments = label.toLowerCase().includes(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toLowerCase());
  const hasSearchTerm = Boolean(searchTerm);
  const isSearchMatching = hasSearchTerm && searchTermMatchesPayments;
  return !hasSearchTerm || isSearchMatching;
});
export const getSearchFilteredDefaultModules = basicSelector(state => {
  const defaultModuleSpecs = getDisplayOrderDefaultModuleSpecs(state);
  const searchTerm = getModulesSearchTerm(state);
  const allModules = Object.values(defaultModuleSpecs);
  return allModules.filter(module => {
    const specName = !getIsModuleDefault(module) && module.displayName;
    const translatedModuleLabel = specName || getTranslatedModuleLabel(state, module.name, module.moduleId);
    return translatedModuleLabel.toLowerCase().includes(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toLowerCase());
  });
});
export const getCountOfDefaultFilteredModules = createSelector([getSearchFilteredDefaultModules, getIsPaymentModuleVisible], (searchFilteredDefaultModules, isPaymentModuleVisible) => searchFilteredDefaultModules.length + (isPaymentModuleVisible ? 1 : 0));
export const getAllCustomModuleLabels = basicSelectorWithStats(state => {
  const allModules = getMarketplaceOrCreatedModuleSpecs(state);
  const otherModuleLabels = {};
  Object.values(allModules).forEach(m => {
    const moduleName = m.displayName || m.name;
    otherModuleLabels[moduleName] = m.displayName || getTranslatedModuleLabel(state, moduleName, m.moduleId);
  });
  return otherModuleLabels;
});
export const getSortedAndFilteredCustomModules = createSelector([getMarketplaceOrCreatedModuleSpecs, getAllCustomModuleLabels, getModulesSearchTerm], (customModuleSpecs, customModuleLabels, searchTerm) => {
  const specsArray = Object.values(customModuleSpecs);
  const filteredSpecs = searchTerm ? specsArray.filter(({
    displayName,
    name
  }) => {
    const specName = (displayName || name).toLowerCase();
    return specName.includes(searchTerm.toLowerCase());
  }) : specsArray;
  return sortBy(filteredSpecs, ({
    displayName,
    name
  }) => {
    var _customModuleLabels$s;
    const specName = displayName || name;
    return ((_customModuleLabels$s = customModuleLabels[specName]) === null || _customModuleLabels$s === void 0 ? void 0 : _customModuleLabels$s.toLowerCase()) || '';
  });
});
export const getHasCustomModules = createSelector([getSortedAndFilteredCustomModules], sortedAndFilteredCustomModules => sortedAndFilteredCustomModules.length > 0);
export const getCountOfCustomFilteredModules = createSelector([getSortedAndFilteredCustomModules], sortedAndFilteredCustomModules => sortedAndFilteredCustomModules.length);
export const getMaxWidthForElement = basicSelectorWithStats((state, id) => {
  if (!getIsDragDropEmail(state) && !getIsModuleInsideFlexArea(state, id)) {
    return MAX_SAFE_INTEGER;
  }
  const elements = getElementsWithMaxWidth(state);
  const element = elements.find(el => el.get('id') === id);
  if (element) {
    return element.get('maxWidth');
  }
  return MAX_EMAIL_WIDTH;
});
export const getMaxWidthForElementPlaceholder = basicSelectorWithStats((state, id) => {
  const maxWidth = getMaxWidthForElement(state, id);
  if (maxWidth === MAX_SAFE_INTEGER) {
    return MAX_SAFE_INTEGER;
  }
  if (getIsInMobileBreakpointMode(state)) {
    const containingSection = findContainingSection(getSections(state), id);
    if (containingSection.getIn(['style', 'stack']) !== STACK.NONE) {
      return MAX_EMAIL_WIDTH;
    }
  }
  return maxWidth;
});
export const getModulesOutsideFlexArea = createSelector([getInpageModulesOutsideContainers, getModulesInsideFlexArea], (modules, modulesIdsInFlexArea) => {
  return modules.filter(module => !module.isInContainer && !module.layout_section_id && !modulesIdsInFlexArea.find(m => m.id === module.id));
});
export const getIsSelectedModuleInFlexArea = createSelector([getSelectedElement, getModulesInsideFlexArea], (selectedElement, modulesIdsInFlexArea) => {
  return selectedElement && !!modulesIdsInFlexArea.find(m => m.id === selectedElement.get('id'));
});
export const getSelectedElementHasErrors = basicSelector(state => {
  const selectedModuleSpec = getSchemaForSelectedModule(state);
  return (selectedModuleSpec === null || selectedModuleSpec === void 0 ? void 0 : selectedModuleSpec.moduleId) === undefined || isEmptyObject(selectedModuleSpec) || !getIsEmailTemplate(state) && getSelectedElementSpecIsMissing(state);
});
export const getIsSelectedElementWebVersionModuleInsideDndArea = createSelector(getSelectedElement, selectedElement => selectedElement && getIsWebVersionModule(selectedElement));
export const getHiddenElementsForActiveBreakpoint = createSelector([getElements, getActiveBreakpointName, getSections], (elements, activeBreakpointName, sections) => {
  return elements.filter(element => {
    const containingSection = findContainingSection(sections, element === null || element === void 0 ? void 0 : element.get('id'));
    return isHiddenForBreakpoint(activeBreakpointName, element === null || element === void 0 ? void 0 : element.get('styles')) || isHiddenForBreakpoint(activeBreakpointName, containingSection === null || containingSection === void 0 ? void 0 : containingSection.get('style'));
  });
});
export const getHiddenElements = createSelector([getElements, getSections], (elements, sections) => {
  return elements.filter(element => {
    const containingSection = findContainingSection(sections, element.get('id'));
    if (!containingSection) {
      return false;
    }
    const isCompletelyHidden = isHiddenForAllBreakpoints(element.get('styles')) || isHiddenForAllBreakpoints(containingSection.get('style'));
    return isCompletelyHidden ||
    // If a section is hidden on mobile and contains a module that is hidden
    // on desktop (or vice versa) then that module is naturally also hidden.
    isHiddenForMobileBreakpoint(element.get('styles')) && isHiddenForDefaultBreakpoint(containingSection.get('style')) || isHiddenForDefaultBreakpoint(element.get('styles')) && isHiddenForMobileBreakpoint(containingSection.get('style'));
  });
});
export const getEmailContainsModules = createSelector([getLegacyBuiltinModules, getSortedStaticModulesAndContainers.gated, getHiddenModules.gated, getIsDragDropEmail, getContentWidgets.gated], (builtinModules, staticModules, hiddenModules, isDragDropEmail, contentWidgets) => {
  if (isDragDropEmail) {
    return contentWidgets.size > 0;
  }
  return builtinModules.filter(m => m.get('rendered')).size + staticModules.size + hiddenModules.size > 0;
});
export const getIsFetchingModuleSchemaWithId = createSelector([getBatchFetchModuleSchemasRequest, (__, moduleId) => moduleId], (batchFetchModuleSchemasRequest, moduleId) => {
  var _batchFetchModuleSche;
  return Boolean(requestStarted(batchFetchModuleSchemasRequest) && ( // @ts-expect-error can't infer value on Artifact
  (_batchFetchModuleSche = batchFetchModuleSchemasRequest.moduleIds) === null || _batchFetchModuleSche === void 0 ? void 0 : _batchFetchModuleSche.includes(moduleId)));
});
export const getHasFieldsToEditById = basicSelector((state, tab, id) => {
  const element = getElementById(state, id);
  const isDefaultModule = getIsDefaultModule(state, id);
  const isDndModule = getIsModuleInsideFlexArea(state, id);
  const isInlineEditable = getIsModuleInlineEditable(state, element.get('module_id'), element);
  const moduleSpec = getModuleSpec(state, element);
  const scopes = getScopes(state);
  const isCustomEditor = getIsCustomEmail(state);
  if (isInlineEditable) {
    return tab === STYLE;
  }
  if (isDndModule && tab === STYLE) {
    return true;
  }
  if (tab === CONTENT && hasNoFieldsInContentTab(moduleSpec)) {
    return false;
  }
  if (isCustomEditor && isDefaultModuleWithStyleField(moduleSpec) && tab === STYLE) {
    return true;
  }
  const options = {
    module: element.toJS(),
    moduleSpec: withModuleTabMigrationFilter({
      isDefaultModule,
      moduleSpec,
      tab
    })
  };
  return doesTabHaveFields(tab, options, scopes);
});
const getAvailableRecommendedModuleIds = createSelector([getRecommendedModuleIDs], recommendedModuleIds => recommendedModuleIds);
export const getRecommendedModuleSpecs = getSpecsForModuleIds(getAvailableRecommendedModuleIds);